import { AuthService } from "./auth.service";
import * as i0 from "@angular/core";
import * as i1 from "./auth.service";
export class LoginGuard {
    constructor(service) {
        this.service = service;
    }
    canActivate() {
        const isLoggedIn = this.service.isAuthenticated;
        if (!isLoggedIn) {
            this.service.logout();
        }
        return isLoggedIn;
    }
}
LoginGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function LoginGuard_Factory() { return new LoginGuard(i0.ɵɵinject(i1.AuthService)); }, token: LoginGuard, providedIn: "root" });
